import { useQuery } from '@tanstack/react-query';
import { patientQuestionnaires } from '../../apis/questionnaire';
import { getQuestionnairesList } from '../../pages/task/types';

function useQuestionnaires(params: getQuestionnairesList) {
  const { patientId, type } = params;

  const { data, isError, isLoading, isRefetching } = useQuery({
    queryKey: [`${type}questionnaires-list`],
    queryFn: () => patientQuestionnaires({ patient_id: patientId, type }),
  });

  return {
    isLoading: isLoading,
    isError: isError,
    isRefetching: isRefetching,
    questionnaires: data?.questionnaires,
  };
}

export default useQuestionnaires;
